import React from 'react';
import { connect } from 'react-redux';
import CasesTableContainer from 'src/ui/features/Cases/containers/CasesTableContainer';

class EmployeeCasesContainer extends React.Component {
  render() {
    const { employeeId } = this.props.match.params;
    const { history, team } = this.props;
    return (
      <CasesTableContainer
        history={history}
        hideLandingHeader={true}
        defaultFilterValues={{
          caseStatusType: 'All',
          sortColumn: 'targetDate',
          employeeId,
          viewType: team === true ? 'teamCase' : 'myCase',
        }}
      />
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeCasesContainer);
